<!--国外账单详情页-->
<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_InternationalBill')"
      :width="isZh ? '1000px' : '1100px'"
      :close-on-click-modal="false"
      class="app-main-inner"
    >
      <div v-show="expandedGrid" style="display:flex;flex-direction:row">
        <div style="flex-grow:1;display:flex;flex-direction:column">
          <el-form label-position="left" :label-width="isZh ? '90px' : '135px'" :model="billing">
            <el-form-item :label="$t('SeaExport.MainOffice')">
              <el-tooltip :content="mainOfficeChineseName" placement="bottom">
                <el-select
                  v-model="mainOffice"
                  :placeholder="$t('Message.PleaseSelect')"
                  :clearable="false"
                  size="mini"
                >
                  <el-tooltip
                    v-for="office in officeList"
                    :key="office.uuid"
                    :content="office.chineseName"
                    placement="left"
                  >
                    <el-option
                      :value="office.officeId"
                      :label="office.code"
                    />
                  </el-tooltip>
                </el-select>
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillNo')">
              <el-input v-model="billing.billingNo" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillType')">
              <el-input v-model="billingArDesc" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillAmount')">
              <el-input v-model="billing.taxAmount" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_CurrencyRequirements')">
              <div style="display: flex">
                <el-input v-model="currencyRequirement" :disabled="true" style="width: 200px;padding-right: 10px" />
                <el-checkbox v-if="!billing.uuid && customerDetail.currencyRequirements === 3" v-model="splitBillButton" no="splitBill" style="display: block;" @change="splitBillChangeEvent">{{ $t('Message.SplitBill') }} </el-checkbox>
              </div>
            </el-form-item>
          </el-form>
          <div style="display:flex;flex-direction:row;padding:2px 0">
            <div :style="isZh ? 'width:65px;' : 'width:95px;'">
              <span>{{ $t('Billing.billingJob_originalCurrency') }}</span>
            </div>
            <div :style="(isZh ? 'width:95px;' : 'width:100px;') + 'margin-left: 5px;'">
              <span>{{ $t('Billing.billingJob_amountOfMoney') }}</span>
            </div>
            <div style="width:95px;margin-left: 20px;">
              <span>{{ $t('Billing.billing_exchangeRate') }}</span>
            </div>
            <div style="width:95px;margin-left: 30px;">
              <span>{{ $t('Billing.billingJob_billAndCurrency') }}</span>
            </div>
            <div v-show="splitBillButton" style="width:95px;margin-left: 30px;">
              <span>{{ $t('Billing.billing_billAmount') }}</span>
            </div>
          </div>
          <div style="display:flex;flex-direction:row;padding:2px 0">
            <el-input v-model="billing.sourceCurrency1" :disabled="true" :style="(isZh ? 'width:65px;' : 'width:95px;') + 'margin-right:5px'" />
            <el-input-number v-model="billing.amount1" :style="(isZh ? 'width: 110px;' : 'width: 115px;') + 'margin-right:5px'" controls-position="right" :min="-999999999999" :max="999999999999" :precision="2" :disabled="true" />
            <num-input
              v-model="billing.sourceRate1"
              :min="0"
              :max="999999999999"
              :precision="8"
              :truncated-precision="sourceRate1Precision"
              :disabled="!sourceRateEnable.sourceRate1"
              style="width: 120px;margin-right:5px"
              @change="calculateAmount"
            />
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_Currency"
              :default-value="billing.currency"
              style="width:120px;margin-right:5px"
              :clearable="false"
              :disabled="!unCommitOrPrint || splitBillButton"
              @parentCallBack="currencyChangeEvent"
            />
            <el-input-number v-show="splitBillButton" v-model="billing.amount" controls-position="right" :min="-999999999999" :max="999999999999" style="width:120px" :precision="2" :disabled="true" />
          </div>
          <div style="display:flex;flex-direction:row;padding:2px 0">
            <el-input v-show="!splitBillButton" v-model="billing.sourceCurrency2" :disabled="true" :style="(isZh ? 'width:65px;' : 'width:95px;') + 'margin-right:5px'" />
            <el-input-number v-show="!splitBillButton" v-model="billing.amount2" :style="(isZh ? 'width: 110px;' : 'width: 115px;') + 'margin-right:5px'" controls-position="right" :min="-999999999999" :max="999999999999" :precision="2" :disabled="true" />
            <num-input
              v-show="!splitBillButton"
              v-model="billing.sourceRate2"
              :min="0"
              :max="999999999999"
              :precision="8"
              :truncated-precision="sourceRate2Precision"
              :disabled="!sourceRateEnable.sourceRate2"
              style="width: 120px;margin-right:5px"
              @change="calculateAmount"
            />
            <div v-show="!splitBillButton" style="width:95px">
              <span>{{ $t('Billing.billing_billAmount') }}</span>
            </div>
          </div>
          <div style="display:flex;flex-direction:row;padding:2px 0">
            <el-input v-show="!splitBillButton" v-model="billing.sourceCurrency3" :disabled="true" :style="(isZh ? 'width:65px;' : 'width:95px;') + 'margin-right:5px'" />
            <el-input-number v-show="!splitBillButton" v-model="billing.amount3" :style="(isZh ? 'width: 110px;' : 'width: 115px;') + 'margin-right:5px'" controls-position="right" :min="-999999999999" :max="999999999999" :precision="2" :disabled="true" />
            <num-input
              v-show="!splitBillButton"
              v-model="billing.sourceRate3"
              :min="0"
              :max="999999999999"
              :precision="8"
              :truncated-precision="sourceRate3Precision"
              :disabled="!sourceRateEnable.sourceRate3"
              style="width: 120px;margin-right:5px"
              @change="calculateAmount"
            />
            <el-input-number v-show="!splitBillButton" v-model="billing.amount" controls-position="right" :min="-999999999999" :max="999999999999" style="width:120px" :precision="2" :disabled="true" />
          </div>
          <el-form label-position="left" :label-width="isZh ? '100px' : '115px'" :model="billing">
            <div style="display: flex;flex-direction:row;padding:2px 0">
              <el-form-item :label="$t('CargoMsg.Cargo_AccountContacts')">
                <cargo-advance-select
                  :select-type="selectTypeNames.static_data_Contact"
                  :allow-create="true"
                  filterable
                  :cache="false"
                  clearable
                  style="width: 150px;"
                  :disabled="!unCommitOrPrint"
                  :default-value="billing.accountContacts"
                  :static-options="accountContactsArray"
                  @parentCallBack="accountContactChangeEvent"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_AccountContactsTel')">
                <el-input v-model="billing.accountContactsTel" style="width: 150px;" :disabled="!unCommitOrPrint" />
              </el-form-item>
            </div>
            <el-form-item :label="$t('CargoMsg.Cargo_AccountAddr')">
              <el-input v-model="billing.accountAddr" style="width:400px;" :disabled="!unCommitOrPrint" />
            </el-form-item>
            <el-form-item v-show="billing.billingType === '国外账单'" :label="$t('Billing.billingJob_settlementType')">
              <el-select v-model="billing.settlementType" style="width:400px;" :disabled="!unCommitOrPrint">
                <el-option v-if="billing.settlementType === 0" :key="-1" label=" " :value="0" />
                <el-option v-for="(item,index) in SETTLEMENT_TYPE_STATES" :key="index" :label="$store.getters.isZh ? item.chineseName : item.englishName" :value="item.code" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div style="width:10px;height:100%" />
        <div style="flex-grow:1;display:flex;flex-direction:column">
          <el-form label-position="left" :label-width="isZh ? '90px' : '135px'" :model="billing">
            <el-form-item :label="$t('SeaExport.AccountObject')">
              <el-select
                v-model="billing.accountId"
                :placeholder="$t('Message.PleaseSelect')"
                :disabled="!unCommitOrPrint && !isBySettlementAgent"
                size="mini"
                @change="accountCodeChangeEvent"
              >
                <el-option
                  v-for="(item,index) in billingChargeAccounts"
                  :key="index"
                  :label="item.label"
                  :value="item.data"
                />
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('SeaExport.settlementAgent')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :default-value="Number(billing.settlementAgentId)"
                :disabled="!unCommitOrPrint || isBySettlementAgent"
                :cache="false"
                tag-name="chineseName"
                :static-options="settlementAgentArray"
                @parentCallBack="p=>billing.settlementAgentId=p.value"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_InvoiceHeader')">
              <cargo-advance-select
                :select-type="selectTypeNames.static_data_Title"
                :allow-create="true"
                filterable
                :cache="false"
                :disabled="!unCommitOrPrint"
                :default-value="invoiceTitleUuid"
                tag-value="uuid"
                :static-options="titleArray"
                @parentCallBack="titleChangeEvent"
              />
            </el-form-item>
            <el-form-item :label="$t('Partners.CustomerMailbox')">
              <el-input v-model="billing.customerEmail" :disabled="true" no="customerEmail" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DepositBank')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.static_data_TitleBank"
                no="8"
                :default-value="titleBankUuid"
                :disabled="!unCommitOrPrint"
                :cache="false"
                tag-value="uuid"
                :static-options="titleBankArray"
                @parentCallBack="getBankCusFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BankAccount')">
              <el-input v-model="billing.buyerBankAccount" :disabled="true" no="buyerBankAccount" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_OwnerBankOfDeposit')">
              <cargo-advance-select
                filterable
                :cache="false"
                :disabled="!unCommitOrPrint"
                :select-type="selectTypeNames.static_data_BankAccount"
                :default-value="billing.bankAccountId === 0 ? '' : billing.bankAccountId"
                :static-options="ourBankAccountArray"
                @parentCallBack="getOurBankAccountFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BankAccount')">
              <el-input v-model="billing.bankAccount" :disabled="!unCommitOrPrint" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CounterPartyBillingNo')">
              <el-input v-model="billing.counterPartyBillingNo" :disabled="!unCommitOrPrint" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.InputDate')">
              <el-date-picker
                v-model="billing.inputDate"
                type="date"
                :clearable="false"
                :editable="false"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :disabled="!unCommitOrPrint"
                @change="inputDateChange"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Remarks')">
              <el-input v-model="billing.remark" type="textarea" :rows="3" :disabled="!unCommitOrPrint" />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="app-main-inner-row" style="justify-content: center;font-size:30px;">
        <i :class="expandedGrid?'el-icon-caret-top':'el-icon-caret-bottom'" @click="expandedGrid=!expandedGrid" />
      </div>
      <div class="app-main-inner-row" style="justify-content: space-between;padding-left: 0">
        <div>
          <el-button no="Add" type="primary" @click="btnAddEventHandler">{{ this.$t('SeaExport.AddBillCharge') }}</el-button>
          <el-button no="Remove" :disabled="!(billing && !billing.billingGroupUuid && (billing.state === 0 || billing.state === -1 || (billing.state === 2 && !billing.confirmed)) && (!billing.invoiceState || billing.invoiceState === 0) && (!billing.realClearingState || billing.realClearingState === ClearingConstants.CLEARING_STATE_NON.code))" type="primary" @click="removeBillChargeEvent">{{ this.$t('SeaExport.RemoveBillCharge') }}</el-button>
          <el-checkbox v-show="chkShowLclVisible" v-model="chkShowLclSelected" style="margin-left: 10px;" @change="chkChangeHandler">{{ $t('SeaExport.ShowLcl') }}</el-checkbox>
          <!-- 指令操作按钮 -->
          <template v-for="(item, index) in instructionBtns">
            <el-button
              :key="index"
              :no="item.platformInstructionRuleCode"
              :type="getInstructionBtnType(item)"
              :disabled="!item.allowOperate"
              :style="{marginLeft: index === 0 ? '5px' : ''}"
              @click="onInstructionClick(item)"
            >
              {{ getInstructionLabel(item) }}
            </el-button>
          </template>
        </div>
      </div>
      <div class="app-main-inner-row" style="padding-left: 0">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="billing.charge"
          :style="{width:'100%',height:expandedGrid?'':'571px'}"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div slot="footer">
        <el-button
          v-if="splitBillButton"
          :disabled="nowPage === 0"
          type="primary"
          @click="theLastPageHandler"
        >
          {{ $t('Invoice.invoice_theLastPage') }}
        </el-button>
        <el-button
          v-if="splitBillButton"
          :disabled="nowPage === splitCurrencyList.length - 1"
          type="primary"
          @click="theNextPageHandler"
        >
          {{ $t('Invoice.invoice_theNextPage') }}
        </el-button>
        <el-button v-permission="['button_billTab_invoiceFromBilling']" :disabled="applyInvoiceDisabled" type="primary" @click="onApplyInvoiceClick(billing)">{{ $t('Billing.ApplyForInvoicing') }}</el-button>
        <el-button no="Save" type="primary" :disabled="btnSaveEnable" @click="saveBilling">{{ $t('SeaExport.Save') }}</el-button>
        <el-button no="Cancel" style="margin-right: 0" @click="innerVisible=false">{{ $t('SeaExport.Cancel') }}</el-button>
        <span v-if="splitBillButton" style="padding-right: 5px;padding-left: 5px">{{ nowPage + 1 + '/' + splitCurrencyList.length }}</span>
      </div>

      <!--加入费用-->
      <join-charge-dialog
        v-if="showJoinChargeDialog"
        :visible.sync="showJoinChargeDialog"
        :search-item-module="searchItemModule"
        :default-conditions="addChargeCondition"
        @addChargeCallBackEvent="selectedChargeEvent"
      />
    </el-dialog>
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="batchCheckingWindow.lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 账单保存校验弹窗 -->
    <checking-save-job-window
      v-if="checkingSaveJobWindow.visible"
      :visible.sync="checkingSaveJobWindow.visible"
      :lob="checkingSaveJobWindow.lob"
      :row-data="checkingSaveJobWindow.rowData"
      :check-node="checkingSaveJobWindow.checkNode"
      :call-back="checkingSaveJobWindow.callBack"
    />
    <!-- 账单编辑费用弹窗 -->
    <bill-edit-charge-dialog
      v-if="billEditChargeDialog.visible"
      :visible.sync="billEditChargeDialog.visible"
      :title="billEditChargeDialog.title"
      :simple-jobs="billEditChargeDialog.simpleJobs"
      :job="job"
      :charge="billEditChargeDialog.charge"
      :currency-list="billEditChargeDialog.currencyList"
      :billing="billing"
      :split-bill="splitBillButton"
      @callback="saveBillEditChargeCallback"
    />
  </div>
</template>

<script>
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getSettlementAgentsByCmpIdx } from '@/api/company'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import StrUtils from '@/utils/StrUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import { getBankAccountList } from '@/api/bankAccount'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { Billing } from '@/class/model/act/Billing'
import joinChargeDialog from '@/components/Cargo/Act/joinChargeDialog'
import {
  batchCheckPartyBillingNoExist,
  saveOverseaBilling,
  saveOverseaSplitBillingFunc
} from '@/api/clearing/billingNative'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import { Company } from '@/class/model/mdm/Company'
import lodash from 'lodash'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { checkPartyBillingNoExist, setBillingNo } from '@/api/clearing/billingNative'
import { getContactList } from '@/api/partner/contact'
import { queryTitleByCpmIdx } from '@/api/partner/title'
import * as BillingRateUtil from '@/class/cargo/model/utils/BillingRateUtil'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import { BILLING_TYPE_OVERSEA, SETTLEMENT_TYPE_STATES } from '@/class/cargo/model/parameters/BillingConstants'
import * as BillingNativeUtils from '@/class/cargo/model/utils/BillingNativeUtils'
import { getTitleBankList } from '@/api/partner/titleBank'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import NumInput from '@/components/Cargo/Common/NumInput'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import CheckingSaveJobWindow from '@/components/Cargo/Job/CheckingManager/CheckingSaveJobWindow.vue'
import { checkChargeByBillingSaveNode } from '@/api/booking/job'
import BillEditChargeDialog from '@/components/Cargo/Act/billEditChargeDialog'
import { Charge } from '@/class/model/act/Charge'
import BookingUtil from '@/class/cargo/model/utils/BookingUtil'
import { getChargeByUuid } from '@/api/clearing/charge'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { Job } from '@/class/model/booking/Job'

export const MAX_CURRENCY_NUM = 3

export default {
  name: 'SplitOverseaBillingDialog',
  components: {
    CheckingSaveJobWindow,
    BatchCheckingWindow,
    CargoAdvanceSelect,
    joinChargeDialog, // 加入费用弹窗
    NumInput,
    BillEditChargeDialog
  },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: false },
    propBilling: { type: Object, required: false },
    isAddOrEdit: { type: Boolean, default: false }, // true  修改
    debitChargetaxRate: { type: Number, required: false },
    billingChargeDetail: { type: Array, required: false }, //  新建国外账单带入的费用明细
    propBillingChargeAccounts: { type: Array, required: false }, // 结算对象集合
    currentBillingBranchId: { type: Number, required: false }, //  当前账单所属分公司(业务详情-账单页签)
    departmentTeamUser: { type: Array, required: false }, // 同部门的人：佣金(淳宏)判断费用创建人同组
    customerDetail: { type: Object, required: true },
    createOverseaCharge: { type: Boolean, required: false }, // 是否允许国外费用开票
    createBillWay: { type: Number, default: 0 }, // 创建账单方式【0：结算对象 1、结算代理】
    location: { type: String, required: false },
    showWhtTax: { type: Boolean, default: false },
    instructionBtns: { type: Array, default: () => [] }
  },
  data() {
    return {
      ClearingConstants,
      innerVisible: false,
      expandedGrid: true,
      fullscreenLoading: null, // loading
      selectTypeNames: TYPE_NAMES,
      SETTLEMENT_TYPE_STATES,
      showJoinChargeDialog: false,
      searchItemModule: '5042',
      titleBankArray: [], // 开票抬头对应的开票银行,既开户银行集合
      titleBankUuid: '', // 开户银行UUID
      changeStatus: false,
      addChargeCondition: { // 点击加入费用按钮时传递的参数
        exceptKeys: [],
        hasBillPayment: -1,
        hasBilling: -1,
        oversea: -1,
        currency: null,
        accountId: 0
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 行背景色设置
        getRowStyle: function(params) {
          if (params.node.data.receivable) {
            return { background: '#EFEFEF' }
          } else {
            return { background: '#999999' }
          }
        }
      },
      gridParams: {},
      gridApi: null,
      rowData: [],
      isView: true,
      settlementAgentArray: [], // 结算代理集合
      ourBankAccountArray: [], // 我司银行集
      isShowCounterPartyBillingNo: false, // 是否展示代理账单号
      sourceRateEnable: {
        sourceRate1: true, // 第一行汇率是否可编辑，默认不可编辑
        sourceRate2: true, // 第二行汇率是否可编辑，默认不可编辑
        sourceRate3: true // 第三行汇率是否可编辑，默认不可编辑
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null,
        billDataList: []
      },
      checkingSaveJobWindow: {
        visible: false,
        rowData: [],
        lob: '',
        checkNode: 0,
        callBack: null
      },
      billing: new Billing().fillDefaultValue().getData(),
      billingChargeAccounts: [], // 结算对象集合
      mainOffice: 0, // 账单抬头公司
      mainOfficeChineseName: '', // 账单抬头公司对应的公司名称
      officeList: [], // 分公司list
      chkShowLclSelected: false,
      chkShowLclVisible: false, // 是否显示小票费用 checkbox
      lclChargeDetail: [], // 小票费用
      invoiceSyncRate: 0, // 汇率同步参数
      billingArDesc: '', // 账单类型
      removedCharges: [], // 移除掉的费用 freeCharges
      btnDeleteEnabled: true,
      chargeList: [], // 测试
      accountContactsArray: [], // 结算单位联系人
      titleArray: [], // 开票抬头集合
      invoiceTitleUuid: '', // 开票抬头UUID
      initialBilling: null, //
      splitBillData: {}, // 拆分的账单
      splitCurrencyList: [], // 拆分的币种
      nowPage: 0, // 当前页
      settlementAgentsByCmpIdxMap: {}, // 结算代理
      titleByCpmIdxMap: {}, //
      contactListMap: {}, //
      currencyRequirement: null, //
      splitBillButton: false,
      btnSaveEnable: false, // 是否可以点击保存
      isSaveBillRate: false,
      billEditChargeDialog: {
        visible: false,
        title: '',
        simpleJobs: [],
        charge: {},
        currencyList: []
      },
      autoIncrementNum: new AutoIncrementNum(),
      jobChargeCache: new Map() // 业务费用缓存
    }
  },
  computed: {
    unCommitOrPrint() {
      return this.billing.state === 0 || this.billing.state === -1 || this.billing.state === 2
    },
    applyInvoiceDisabled() {
      return !this.createOverseaCharge || !this.billing.uuid || !this.billing.charge || this.billing.charge.findIndex(p => p.needInvoice) < 0
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    isBySettlementAgent() { // 按结算代理新增
      return this.createBillWay === 1 && !this.billing.uuid
    },
    columnDefs() { // 费用列表
      const result = [
        {
          headerName: '', checkboxSelection: true, width: 55,
          sortable: false, suppressMenu: true, suppressSizeToFit: true,
          resizable: false, headerCheckboxSelection: true
        },
        { headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 120 },
        { headerName: this.$t('SeaExport.Receivable'), field: 'receivable', width: 100,
          cellRenderer: (params) => {
            return this.arapComboBoxLabelEnFunc(params.value)
          } },
        { headerName: this.$t('SeaExport.ChargeItem'), field: 'chargeItemId', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          } },
        { headerName: this.$t('SeaExport.Currency'), field: 'currency', width: 100 },
        {
          headerName: this.$t('SeaExport.IncludingTaxAmount'),
          field: 'amount',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          } },
        {
          headerName: this.$t('SeaExport.ExcludingTaxAmount'),
          field: 'excludingTaxAmount',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          } },
        { headerName: this.$t('SeaExport.TaxRate'), field: 'taxRate', width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return ColumnUtils.numberColumnLabelFunc(val, 2, true, true)
              },
              checkInput: (val) => {
                return true
              }
            },
            valueChanged: p => { this.onCellChange(p) }
          }},
        { headerName: this.$t('SeaExport.WhetherCollectingAdvance'), field: 'advance', width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          } },
        { headerName: this.$t('SeaExport.BillAmount'), field: 'taxAmount', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          } },
        { headerName: this.$t('SeaExport.Unit'), field: 'measure', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          } },
        {
          headerName: this.$t('SeaExport.Quantity2'),
          field: 'quantity',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.UnitRate'),
          field: 'unitRate',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          width: 120
        },
        {
          headerName: this.$t('FinanceManage.charge_invoiceHeader'),
          field: 'invoiceTitle',
          hide: true,
          width: 100
        }, {
          headerName: this.$t('FinanceManage.international_settlementAgent'),
          field: 'settlementAgentId',
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.ItemNo'), field: 'jobPono', width: 120, hide: true },
        {
          headerName: this.$t('CargoMsg.Cargo_Business_CustomerRefNo'),
          field: 'jobCustomerRefNo',
          width: 200
        },
        {
          headerName: this.$t('FinanceManage.charge_confirmOrNot'),
          field: 'confirmState',
          colId: 'confirmState',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        }
      ]
      if (this.showWhtTax) {
        result.push({
          headerName: this.$t('FinanceManage.charge_whtTaxRate'),
          field: 'whtTaxRate',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
          field: 'whtTaxLocalAmount',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        }, {
          headerName: this.$t('FinanceManage.charge_notWhtAmount'),
          field: 'chargeNotWhtAmount',
          width: 200,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        })
      }
      return result
    },
    sourceRate1Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billing.sourceCurrency1)
    },
    sourceRate2Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billing.sourceCurrency2)
    },
    sourceRate3Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billing.sourceCurrency3)
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.expandedGrid = true
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        // this.closeHandler()
        this.jobChargeCache.clear()
      }
      this.$emit('update:visible', newVal)
    },
    mainOffice(newVal) {
      if (newVal) {
        const office = getObjectByCache(basicCacheKeys.basic_data_Office, 'officeId', Number(newVal))
        this.mainOfficeChineseName = office ? office.chineseName : ''
      }
    }
  },
  created() {
    this.prepareData()
    if (this.visible) {
      this.innerVisible = true
    }
    this.btnSaveEnable = false
    this.splitBillButton = false
    if (this.customerDetail) {
      switch (this.customerDetail.currencyRequirements) {
        case 0:
        case 1:
          this.currencyRequirement = this.$t('CargoMsg.Cargo_NotSpecified')
          break
        case 2:
          this.currencyRequirement = this.$t('CargoMsg.Cargo_Appoint') + this.customerDetail.appointCurrency
          break
        case 3:
          this.splitBillButton = true
          this.currencyRequirement = this.$t('CargoMsg.Cargo_PaymentInOriginalCurrency')
          break
      }
    }
  },
  async beforeMount() {
    await cache.load(cacheName.CONFIG)
    this.isSaveBillRate = Number(cache.config.get('isSaveBillRate')) === 1
    await this.onShow()
  },
  methods: {
    getInvoiceUuidsFromCharges(charges) {
      const keys = new Set()
      for (const c of (charges || [])) {
        if (c && c.needInvoice && !StrUtils.isEmpty(c.invoiceUuid)) {
          keys.add(c.invoiceUuid)
        }
      }
      return Array.from(keys)
    },
    hasUnInvoicedNeedInvoiceCharge(charges) {
      for (const c of (charges || [])) {
        if (c && c.needInvoice && StrUtils.isEmpty(c.invoiceUuid)) return true
      }
      return false
    },
    onApplyInvoiceClick(billing) {
      const charges = (this.billing && this.billing.charge) ? this.billing.charge : []
      const invoiceUuids = this.getInvoiceUuidsFromCharges(charges)
      const hasUnInvoiced = this.hasUnInvoicedNeedInvoiceCharge(charges)
      if (!hasUnInvoiced && invoiceUuids.length > 0) {
        if (this.$listeners && this.$listeners.viewInvoice) {
          this.$emit('viewInvoice', invoiceUuids)
          return
        }
      }
      this.$emit('applyInvoice', billing)
    },
    async onShow(splitBill = '') {
      this.billing = lodash.cloneDeep(this.propBilling)
      this.billingChargeAccounts = lodash.cloneDeep(this.propBillingChargeAccounts)

      this.billingArDesc = this.arapComboBoxLabelEnFunc(this.billing.ar)
      this.refreshLclChargeDetail()
      if (!splitBill) {
        this.showLclCharge()
      }
      this.syncRateInit()
      if (!splitBill || splitBill === '0') {
        this.nowPage = 0
        // 初始化时 ，计算账单基础数据
        await this.commitProperties()
        await this.queryAccountContact(this.billing.accountId)
      }
      if (this.splitBillButton) {
        this.resetBillSlaveCharges(this.billing)
        // 拆费用账单计算
        await this.setSplitCurrencyData(this.billing.charge)
        const currency = this.splitCurrencyList[0]
        // 根据账单币种取计算好的账单数据
        this.billing = this.splitBillData[currency]
        await this.getComboxAccountCharges()
      }
      // 这个方法需要放在后面执行,因为上面的逻辑中会有变更账单币种的逻辑，下面的方法会根据账单币种带数据
      await this.checkCurrencyBankAccount()
      // 获取结算对象的开票抬头
      this.queryTitleList(this.billing.accountId, !StrUtils.isEmpty(this.billing.title)) // 一定要保证先查询开票抬头，然后再根据开票抬头去查询开票银行
    },
    /**
     * 准备好数据
     */
    async prepareData() {
      await cache.load(cacheName.USER, cacheName.OFFICE_LIST, cacheName.CONFIG)
      this.user = cache.user
      this.officeList = cache.officeList
    },
    async commitProperties() {
      this.removedCharges = []
      // 编辑账单
      if (this.isAddOrEdit) {
        this.btnDeleteEnabled = this.billing.state === 0 || this.billing.state === -1
      }
      this.chargeMainOfficeItem()
      await this.accountCodeChangeEvent()
      await this.fillChangedCurrency('', true)
      await this.calculateAmount()
    },
    // 列编辑修改事件
    onCellChange(params) {
      if (params.field === 'taxRate') { // 按费用-对账金额
        const charge = params.data
        if (!charge) return
        this.priceItemEditEndHandler(params)
      }
    },
    /**
     * 根据各种自动关联账号
     */
    async checkCurrencyBankAccount() {
      await getBankAccountList(this.$store.getters.currentOfficeUuid).then(res => {
        if (res.data && res.data.length > 0) {
          this.ourBankAccountArray = res.data
        }
      })
      await this.setBankData(this.billing)
    },
    async setBankData(billing) {
      if (!billing.uuid) {
        // 新建账单时默认带出账单币种对应的默认银行,如果没有则随机去一条和账单币种相同的银行
        let isFind = false
        let bank = null
        billing.bankAccountId = 0
        billing.bankAccount = ''
        for (let i = 0; i < this.ourBankAccountArray.length; i++) {
          const bankAccount = this.ourBankAccountArray[i]
          if (bankAccount['currency'] === billing.currency) {
            bank = bankAccount
            if (bankAccount['defaultPayment']) {
              billing.bankAccountId = bankAccount['accountId']
              billing.bankAccount = bankAccount['accountNo']
              isFind = true
              break
            }
          }
        }
        if (!isFind && bank) {
          billing.bankAccountId = bank['accountId']
          billing.bankAccount = bank['accountNo']
        }
      }
    },
    changeOurBankByCurrency() {
      const ourBankAccountArray = this.ourBankAccountArray
      let isFind = false
      let bank = null
      for (let i = 0; i < ourBankAccountArray.length; i++) {
        const bankAccount = ourBankAccountArray[i]
        if (bankAccount['currency'] === this.billing.currency) {
          bank = bankAccount
          if (bankAccount['defaultPayment']) {
            this.billing.bankAccountId = bankAccount['accountId']
            this.billing.bankAccount = bankAccount['accountNo']
            isFind = true
            break
          }
        }
      }
      if (!isFind) {
        if (bank) {
          this.billing.bankAccountId = bank['accountId']
          this.billing.bankAccount = bank['accountNo']
        } else {
          this.billing.bankAccountId = 0
          this.billing.bankAccount = ''
        }
      }
    },
    /**
     * 账单抬头公司
     */
    chargeMainOfficeItem() {
      if (this.billing.titleBranchId === 0) {
        this.mainOffice = this.$store.getters.currentOfficeId
      } else {
        this.mainOffice = this.billing.titleBranchId
      }
    },
    /**
     * 刷新小票费用
     */
    refreshLclChargeDetail() {
      this.lclChargeDetail = []
      for (let i = this.billingChargeDetail.length - 1; i >= 0; i--) {
        const charge = this.billingChargeDetail[i]
        if (charge.jobUuid !== this.job.uuid) {
          this.lclChargeDetail.push(charge)
        }
      }
    },
    /**
     * 是否显示小票费用
     */
    showLclCharge() {
      this.chkShowLclSelected = LocalStorageUtils.getConfiguration('showLclCharge') || false
      this.chkShowLclVisible = (this.job.masterFlag && StrUtils.isEmpty(this.billing.uuid))
    },

    // 结算对象选择 事件
    async accountCodeChangeEvent(event = null) {
      const billing = this.billing
      if (event) {
        billing.accoundId = event
      }
      // CARGO-7869
      if (!this.isAddOrEdit && !this.splitBillButton) {
        billing.currency = this.getDefaultCurrency()
      }
      await this.getComboxAccountCharges()
      await this.fillChangedCurrency()
      await this.calculateAmount()
      await this.refreshBillingChargeAmount()
      this.priceItemEditEndHandler()

      if (this.isBySettlementAgent) { // 按结算代理方式
        if (this.billing.settlementAgentId && !this.settlementAgentArray.includes(this.billing.settlementAgentId)) {
          const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.billing.settlementAgentId)
          if (company) {
            this.settlementAgentArray = [company]
          }
        }
      } else {
        await this.fillViewSettlementAgent()// 结算代理
      }
      await this.queryAccountContact(this.billing.accountId)
      // 手动调整结算单位
      if (event) {
        await this.queryTitleList2(this.billing.accountId)
      } else {
        this.queryTitleList(this.billing.accountId, !StrUtils.isEmpty(this.billing.title))
      }
      // 更新结算单位地址
      const accountCompany = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.billing.accountId)
      if (accountCompany) {
        this.billing.accountAddr = accountCompany.accountAddr
      }
    },

    // 无 论是查看，编辑，新增账单，都要重新进行填充页面的结算代理（）
    async fillViewSettlementAgent() {
      // 根据结算对象ID找对应的结算对象
      const company = this.querySettlement(this.billing.accountId)
      await this.querySettlementAgentList(this.billing.accountId, company)
    },
    /**
     * 编辑费用税率
     */
    priceItemEditEndHandler(event = null) {
      // 税率编辑
      if (event) {
        const cost = event.data
        cost.taxRate = isNaN(cost.taxRate) ? 0.00 : cost.taxRate
        ChargeUtils.calculateTax(cost, cost.excludingTaxAmount, parseFloat(cost.taxRate))
        // 刷新aggrid
        this.gridApi.refreshCells({ force: true })
      }
      this.calculateAmount()
      this.refBillingTaxAmount()
    },
    /**
     * 汇总费用税额
     */
    refBillingTaxAmount() {
      const _billing = this.billing
      _billing.taxAmount = 0
      let taxAmount = 0
      for (const charge of _billing.charge) {
        taxAmount += charge.taxAmount
      }
      _billing.taxAmount = Math.abs(Number(taxAmount.toFixed(2)))
    },
    /**
     * 如果账单类型是DEBIT，则根据配置参数
     * 把所有费用的税率刷成6%，计算下税额
     * 收的情况下才有税
     */
    async refreshBillingChargeAmount() {
      const _billing = this.billing
      if (_billing.charge == null || _billing.charge.length === 0) return
      if (this.isAddBillTaxAmount) {
        let charge
        if (await this.getBillAmount() > 0) {
          for (charge of _billing.charge) {
            charge.taxRate = this.debitChargetaxRate
            ChargeUtils.calculateTax(charge, charge.excludingTaxAmount, charge.taxRate)
          }
        } else {
          for (charge of _billing.charge) {
            charge.amount = charge.excludingTaxAmount
            charge.taxRate = 0
            charge.taxAmount = 0
          }
        }
      }
    },
    async getBillAmount() {
      const billing = this.billing
      let sumAmount = 0
      for (const row of this.billingChargeDetail) {
        if (row.receivable) {
          if (row.currency !== billing.currency) {
            sumAmount += row.amount * await this.getRate(row.currency)
          } else {
            sumAmount += row.amount
          }
        } else {
          if (row.currency !== billing.currency) {
            sumAmount -= row.amount * await this.getRate(row.currency)
          } else {
            sumAmount -= row.amount
          }
        }
      }
      return sumAmount
    },

    async getComboxAccountCharges() {
      const billing = this.billing
      if (!StrUtils.isEmpty(this.billing.uuid)) {
        return
      }
      if (this.splitBillButton) {
        for (const billCurrency of this.splitCurrencyList) {
          const currencyBill = this.splitBillData[billCurrency]
          if (!currencyBill) {
            continue
          }
          this.resetBillSlaveCharges(this.billing, true)
          await this.setBankData(currencyBill)
          await this.fillChangedCurrency(currencyBill, true)
        }
        return
      }
      if (!this.billing.accountId) {
        this.$message.warning(this.$t('Message.NoSelectSettlement'))
        return
      }
      this.resetBillSlaveCharges(this.billing)
      billing.currency = this.getDefaultCurrency()
      // 币种发生变更以后, 需要重新获取账单汇率
      await this.updateBillingRate()
    },
    resetBillSlaveCharges(billing, byCurrency = false) {
      billing.charge = []
      const field = !this.isBySettlementAgent ? 'accountId' : 'settlementAgentId'
      const cmpIdx = !this.isBySettlementAgent ? billing.accountId : billing.settlementAgentId
      for (const charge of this.billingChargeDetail) {
        if (byCurrency && charge.currency !== billing.currency) {
          continue
        }
        if (charge[field] === cmpIdx && (this.chkShowLclSelected ? true : charge.jobUuid === this.job.uuid)) {
          billing.charge.push(charge)
        }
      }
    },
    /**
     * 如果一张账单里既有USD又有其它币种，默认USD
     */
    getDefaultCurrency() {
      if (this.customerDetail.currencyRequirements === 2 && this.customerDetail.appointCurrency) {
        return this.customerDetail.appointCurrency
      }
      const accountId = this.billing.accountId
      const field = !this.isBySettlementAgent ? 'accountId' : 'settlementAgentId'
      const cmpIdx = !this.isBySettlementAgent ? accountId : this.billing.settlementAgentId
      const billingCharge = []
      for (const charge of this.billingChargeDetail) {
        if (charge[field] === cmpIdx && (this.chkShowLclSelected ? true : charge.jobUuid === this.job.uuid)) {
          billingCharge.push(charge)
        }
      }
      if (billingCharge.length === 0) return ''
      const temp = []
      let currency = 'USD'
      for (const charge2 of billingCharge) {
        if (temp.indexOf(charge2.currency) === -1) {
          temp.push(charge2.currency)
        }
      }
      const localCurrency = this.currentBillingBranchId > 0 ? RateUtil.localCurrencyByOfficeId(this.currentBillingBranchId) : RateUtil.localCurrencyByOffice()
      // 费用列表1种币种 则默认值相同
      if (temp && temp.length === 1) {
        currency = temp[0]
      } else if (temp && temp.length === 2 && temp.indexOf(localCurrency) !== -1) { // 费用列表2种币种且包含RMB 则默认取非人民币
        if (temp[0] === localCurrency) {
          currency = temp[1]
        } else {
          currency = temp[0]
        }
      } else if (temp && temp.length === 2 && temp.indexOf(localCurrency) === -1) { // 费用列表2种币种且不包含RMB 则随机取一种币种
        currency = temp[0]
      } else if (temp && temp.length >= 3) { // 费用列表大于等于3种币种 则随机取一种币种
        currency = temp[0]
      }
      return currency
    },

    syncRateInit() {
      this.invoiceSyncRate = parseInt(cache.config.get('invoiceSyncRate'))
    },
    // 开户银行回调事件
    getBankCusFromChild(obj) {
      this.titleBankUuid = obj.uuid
      this.billing.buyerBank = obj.bank
      this.billing.buyerBankAccount = obj.bankAccount
    },
    // 我司银行账号下拉选择时,带出默认维护的银行账号
    getOurBankAccountFromChild(obj) {
      this.billing.bankAccountId = obj.accountId
      this.billing.bankAccount = obj.accountNo
    },
    // 获取结算代理
    async querySettlementAgentList(accountId, account = null) {
      let settlementAgentId = 0
      let settlementAgentArray = this.settlementAgentsByCmpIdxMap[accountId]
      if (!settlementAgentArray) {
        settlementAgentArray = await getSettlementAgentsByCmpIdx(accountId).then(res => {
          return res.data
        })
        this.settlementAgentsByCmpIdxMap[accountId] = settlementAgentArray
      }
      if (settlementAgentArray && settlementAgentArray.length > 0) {
        const settlementAgent = settlementAgentArray[0]
        settlementAgentId = settlementAgent['cmpIdx']
      } else {
        settlementAgentArray = []
        settlementAgentId = accountId
      }
      if (settlementAgentArray.indexOf(account) < 0) {
        settlementAgentArray.push(account)
      }
      this.settlementAgentArray = settlementAgentArray

      // 新增账单时给结算代理赋值
      if (!this.billing.uuid) {
        this.billing.settlementAgentId = settlementAgentId
      }
    },
    // 根据结算对象ID获取结算对象
    querySettlement(accountId = 0) {
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(accountId))
      if (company) {
        if (this.$store.getters.language === 'zh') {
          this.billing.settlement = company['chineseName']
        } else {
          this.billing.settlement = company['englishName']
        }
      }
      return company
    },
    // 账单币种修改事件 ddlCurrency_changeHandler
    async currencyChangeEvent(obj = null) {
      const billing = this.billing
      if (obj) {
        billing.currency = obj.value
      }
      await this.updateBillingRate()
      await this.fillRate(billing.currency)
      this.changeOurBankByCurrency()
      await this.calculateAmount()
    },
    async fillRate(currency) {
      const billing = this.billing
      for (let i = 0; i < MAX_CURRENCY_NUM; i++) {
        const sourceCurrency = billing['sourceCurrency' + (i + 1)]
        if (StrUtils.isEmpty(sourceCurrency)) {
          continue
        }

        let rate = 1.0
        if (sourceCurrency === currency) {
          this.sourceRateEnable['sourceRate' + (i + 1)] = false
        } else {
          this.sourceRateEnable['sourceRate' + (i + 1)] = true
          if (this.isSaveBillRate) {
            rate = await BillingRateUtil.getForeignExchangeRateByDate(currency, sourceCurrency, billing.inputDate, null, true)
          } else {
            rate = await RateUtil.getForeignExchangeRateByDate(currency, sourceCurrency, billing.inputDate, billing.branchId, null, true)
          }
        }
        billing['sourceRate' + (i + 1)] = rate
      }
    },
    /**
     * 原币种金额
     * 账单金额
     */
    async calculateAmount(splitBilling = null) {
      let billing = this.billing
      if (splitBilling) {
        billing = splitBilling
      }
      let billingAmount = 0.00// 账单金额
      const currencyAmountMap = {}// 分币种金额合计
      const zeroAmountCurrencys = ChargeUtils.getZeroAmountCurrencys(billing.charge)
      for (const charge of billing.charge) {
        const chargeCurrency = charge.currency
        // console.log('========currencyAmountMap', currencyAmountMap, chargeCurrency, currencyAmountMap.hasOwnProperty(chargeCurrency))
        if (!currencyAmountMap.hasOwnProperty(chargeCurrency)) {
          const arraryCharges = []
          arraryCharges.push(charge)
          currencyAmountMap[chargeCurrency] = arraryCharges
        } else {
          const cuyCharges = currencyAmountMap[chargeCurrency]
          cuyCharges.push(charge)
          currencyAmountMap[chargeCurrency] = cuyCharges
        }
        if (zeroAmountCurrencys.includes(chargeCurrency)) continue
        const rate = await this.getRate(chargeCurrency)
        // let chargeAmount:Number = (charge.isReceivable ? charge.amount : -charge.amount) * rate
        // CARGO-6875，修改账单金额计算方式
        // const chargeAmount = NumberUtils.roundHalfUp((charge.receivable ? charge.amount : -charge.amount) * rate, 2)
        const chargeAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency((charge.receivable ? charge.amount : -charge.amount) * rate, billing.currency), 2)
        billingAmount += chargeAmount
        billingAmount = RateUtil.getAmountByCurrency(billingAmount, billing.currency)
      }
      // 账单金额
      billing.amount = Math.abs(billingAmount)
      billing.ar = billingAmount > 0
      this.billingArDesc = this.arapComboBoxLabelEnFunc(billing.ar)
      // 计算原币种金额
      this.fillViewCurrencyAmount(currencyAmountMap, billing)
    },
    /**
     * 计算原币种金额
     */
    fillViewCurrencyAmount(currencyAmountMap, billing) {
      for (let i = 0; i < MAX_CURRENCY_NUM; i++) {
        const sourceCurrency = billing['sourceCurrency' + (i + 1)]
        const charges = currencyAmountMap[sourceCurrency]
        let currencyAmount = 0.00
        if (charges && charges.length > 0) {
          for (const charge of charges) {
            currencyAmount += (charge.receivable ? charge.amount : -charge.amount)
          }
        }
        currencyAmount = billing.ar ? currencyAmount : -currencyAmount
        billing['amount' + (i + 1)] = currencyAmount
        if (StrUtils.isEmpty(sourceCurrency)) { billing['amount' + (i + 1)] = '' } else { billing['amount' + (i + 1)] = NumberUtils.formatNumber(currencyAmount, 2) }
      }
    },
    /**
     * 账单分币种
     */
    async fillChangedCurrency(splitBilling = null, isFirstLoad = false) {
      let billing = this.billing
      if (splitBilling) {
        billing = splitBilling
      }
      if (billing === null) return
      const objCurrency = {}
      for (const charge of billing.charge) {
        if (!objCurrency.hasOwnProperty(charge.currency)) {
          if (charge.currency === billing.currency) {
            objCurrency[charge.currency] = 1.0
          } else {
            if (isFirstLoad) {
              objCurrency[charge.currency] = await this.getRateByBilling(billing, charge.currency)
            } else {
              const pageRate = await this.getRate(charge.currency)
              objCurrency[charge.currency] = pageRate === 0 ? await this.getRateByBilling(billing, charge.currency) : pageRate
            }
          }
        }
      }

      // 先重置几个输入框
      for (let i = 0; i < MAX_CURRENCY_NUM; i++) {
        billing['sourceCurrency' + (i + 1)] = ''
        this.sourceRateEnable['sourceRate' + (i + 1)] = false
        billing['sourceRate' + (i + 1)] = 0.0
      }
      // CARGO-7869
      // ddlCurrency.currency = getDefaultCurrency();
      let index = 0
      for (const c in objCurrency) {
        if (index < MAX_CURRENCY_NUM) {
          billing['sourceRate' + (index + 1)] = await this.getRate(c, objCurrency)
          billing['sourceCurrency' + (index + 1)] = c
          this.sourceRateEnable['sourceRate' + (index + 1)] = c !== billing.currency
          index++
        }
      }
      // CARGO-29259，新建国外账单账单币种默认是RMB，费用原币种有USD的金额没有计算出来
      if (isFirstLoad) await this.calculateAmount(billing)
    },
    /**
     * 通过帐单上的汇率获取汇率,若没有,则从系统中获取汇率
     * @param billing
     * @param currency
     * @return
     */
    async getRateByBilling(billing, currency) {
      let rate = 0.0
      if (billing === null || StrUtils.isEmpty(currency)) return rate
      for (let i = 1; i <= MAX_CURRENCY_NUM; i++) {
        const sourceCurrency = billing['sourceCurrency ' + i]
        if (!StrUtils.isEmpty(sourceCurrency) && sourceCurrency === currency) {
          rate = Number(billing['sourceRate' + i])
          break
        }
      }
      if (rate === 0.0) {
        if (this.isSaveBillRate) {
          rate = await BillingRateUtil.getForeignExchangeRateByDate(billing.currency, currency, billing.inputDate)
        } else {
          rate = await RateUtil.getForeignExchangeRateByDate(billing.currency, currency, billing.inputDate, billing.branchId)
        }
      }
      return rate
    },
    /**
     * 根据币种获取页面币种的汇率
     * 若页面中已经存在汇率则直接取值,若没有则取系统维护汇率
     */
    async getRate(sourceCurrency, cacheMap = null) {
      const billing = this.billing
      let currencyRate = 0
      if (sourceCurrency) {
        // CARGO-7869
        // const currency:String = getDefaultCurrency()
        const currency = this.billing.currency
        if (sourceCurrency === currency) {
          currencyRate = 1.0
        } else {
          for (let i = 0; i < MAX_CURRENCY_NUM; i++) {
            const sourceCurrencyPage = cacheMap === null ? billing['sourceCurrency' + (i + 1)] : sourceCurrency
            if (sourceCurrencyPage === sourceCurrency) {
              currencyRate = cacheMap == null ? billing['sourceRate' + (i + 1)] : cacheMap[sourceCurrency]
              break
            } else if (billing !== null) {
              if (this.isSaveBillRate) {
                currencyRate = await BillingRateUtil.getForeignExchangeRateByDate(currency, sourceCurrency, billing.inputDate, null, true)
              } else {
                currencyRate = await RateUtil.getForeignExchangeRateByDate(currency, sourceCurrency, billing.inputDate, billing.branchId, null, true)
              }
            }
          }
        }
      }
      return currencyRate
    },
    // 获取过滤费用列表
    getExceptChargeKeys() {
      const keys = []
      for (const c of this.billing.charge) {
        keys.push(c.uuid)
      }
      return keys
    },
    // 加入费用
    btnAddEventHandler() {
      if (this.billing.source === ChargeConstants.ETOWER_ONE.chineseName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BillNotAllowEditEtowerOne'))
        return
      }
      this.addChargeCondition.exceptKeys = this.getExceptChargeKeys()
      this.addChargeCondition.oversea = 1
      this.addChargeCondition.accountId = this.billing.accountId
      this.addChargeCondition.hasBilling = 0
      this.addChargeCondition.settlementAgentId = this.billing.settlementAgentId
      this.addChargeCondition.createBillWay = this.createBillWay
      if (this.createBillWay === 1) {
        this.searchItemModule = '5044'
      }
      if (this.currentBillingBranchId > 0) {
        // 账单所属分公司
        this.addChargeCondition.currentBillingBranchId = this.currentBillingBranchId
        // 费用创建人同组
        let roleCreatedBy = []
        if (this.departmentTeamUser != null) {
          roleCreatedBy = [... this.departmentTeamUser]
        }
        roleCreatedBy.push(this.$store.getters.userId)
        this.addChargeCondition.roleCreatedBy = roleCreatedBy
      }
      // 拆分账单时，固定币种
      if (this.splitBillButton) {
        this.addChargeCondition.currency = this.billing.currency
      }
      this.showJoinChargeDialog = true
    },

    // 加入费用回调事件 selectedChargeEventdep
    async selectedChargeEvent(charges) {
      const loading = getLoading4Cxt(this)
      try {
        this.showJoinChargeDialog = false
        const billing = this.billing
        //  组装费用 list 列属性
        for (const c of charges) {
          // if (c.chargeOffsetState === 0 && c.chargeVerifiedAmount === 0){
          if (c.chargeOffsetState === 0) {
            const buildChargeObj = {}
            buildChargeObj.version = c.version
            buildChargeObj.uuid = c.uuid
            buildChargeObj.receivable = c.chargeReceivable
            buildChargeObj.chargeItemId = c.chargeChargeItemId
            buildChargeObj.currency = c.chargeCurrency
            buildChargeObj.amount = c.chargeAmount
            buildChargeObj.excludingTaxAmount = c.chargeExcludingTaxAmount
            buildChargeObj.taxRate = c.chargeTaxRate
            buildChargeObj.advance = c.chargeAdvance
            buildChargeObj.taxAmount = c.chargeTaxAmount
            buildChargeObj.measure = c.chargeMeasure
            buildChargeObj.quantity = c.chargeQuantity
            buildChargeObj.unitRate = c.chargeUnitRate
            buildChargeObj.remarks = c.chargeRemarks
            buildChargeObj.needInvoice = c.needInvoice
            buildChargeObj.invoiceUuid = c.invoiceUuid
            buildChargeObj.jobNo = c.jobJobNo
            // 保存校验需要
            buildChargeObj.offsetState = c.chargeOffsetState
            buildChargeObj.chargeState = c.chargeChargeState
            buildChargeObj.confirmState = c.chargeConfirmState
            buildChargeObj.jobUuid = c.jobUuid
            buildChargeObj.billingUuid = ''
            buildChargeObj.chargeNotWhtAmount = c.chargeNotWhtAmount
            buildChargeObj.whtTaxLocalAmount = c.whtTaxLocalAmount
            buildChargeObj.whtTaxRate = c.chargeWhtTaxRate

            if (c._charge) {
              buildChargeObj._charge = c._charge
              buildChargeObj.refId = c._charge.refId
            }

            const index = billing.charge.findIndex(p => p._charge && p._charge.refId && p._charge.refId === c._charge.refId)
            if (index > -1) {
              billing.charge[index] = buildChargeObj
              this.gridApi.setRowData(billing.charge)
            } else {
              billing.charge.push(buildChargeObj)
            }
          }
        }
        await this.fillChangedCurrency()
        await this.calculateAmount()
        await this.refreshBillingChargeAmount()
        this.priceItemEditEndHandler()
      } finally {
        loading.close()
      }
    },

    // 移除费用 onDelete
    async removeBillChargeEvent() {
      if (this.billing.source === ChargeConstants.ETOWER_ONE.chineseName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BillNotAllowEditEtowerOne'))
        return
      }
      const loading = getLoading4Cxt(this)
      try {
        const collection = this.gridApi.getSelectedRows()

        if (collection.length === 0) { return }
        if (collection.length === this.billing.charge.length) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CanNotRemovedAllCharge'))
          return
        }
        // 记录移除的费用
        for (const charge of collection) {
          const index = this.billing.charge.findIndex(p => p.uuid === charge.uuid)
          this.billing.charge.splice(index, 1)
          if (charge._charge && !charge._charge.uuid) {
            continue
          }
          if (!StrUtils.isEmpty(charge.billingUuid)) {
            if (this.invoiceSyncRate === 1) {
              charge.chargeState = ChargeConstants.STATE_UNCOMMIT.code
            }
            this.removedCharges.push(charge)
          }
        }
        await this.refreshBillingChargeAmount()
        this.priceItemEditEndHandler()
        await this.fillChangedCurrency()
        await this.calculateAmount()
      } finally {
        loading.close()
      }
    },
    // 彻底删除费用
    async deleteBillChargeEvent(collection) {
      if (this.billing.source === ChargeConstants.ETOWER_ONE.chineseName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BillNotAllowEditEtowerOne'))
        return
      }
      const loading = getLoading4Cxt(this)
      try {
        if (collection.length === 0) { return }
        if (collection.length === this.billing.charge.length) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CanNotRemovedAllCharge'))
          return
        }
        this.billing.deletedChargeKeys = this.billing.deletedChargeKeys || []
        // 记录移除的费用
        for (const charge of collection) {
          const index = this.billing.charge.findIndex(p => p.uuid === charge.uuid)
          this.billing.charge.splice(index, 1)
          if (charge._charge && !charge._charge.uuid) {
            continue
          }
          if (!StrUtils.isEmpty(charge.billingUuid)) {
            if (this.invoiceSyncRate === 1) {
              charge.chargeState = ChargeConstants.STATE_UNCOMMIT.code
            }
            this.removedCharges.push(charge)
          }
          this.billing.deletedChargeKeys.push(charge.uuid)
        }
        await this.refreshBillingChargeAmount()
        this.priceItemEditEndHandler()
        await this.fillChangedCurrency()
        await this.calculateAmount()
      } finally {
        loading.close()
      }
    },
    async saveBilling() {
      // 判断是否开启验证规则
      await cache.load(cacheName.CONFIG)
      const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      if (useCheckRule) {
        const checkNodeFlag = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_SAVE_BILLING.code, this.$store.getters.currentOfficeId)
        if (checkNodeFlag) {
          // 执行校验并处理校验结果
          const result = await this.performBillingValidation()
          if (result && result.needShowDialog) {
            this.showBillingValidationDialog(result.data)
          } else {
            await this.saveBillHandler()
          }
        } else {
          await this.saveBillHandler()
        }
      } else {
        await this.saveBillHandler()
      }
    },
    // 执行账单校验
    async performBillingValidation() {
      // 调用实际的校验接口
      const requestData = {
        checkNode: CheckRuleConstants.NODE_SAVE_BILLING.code,
        chargeUuidList: this.billing.charge ? this.billing.charge.map(item => item.uuid) : [],
        branchId: this.$store.getters.currentOfficeId,
        billing: this.billing || {}
      }

      const loading = getLoading()
      const response = await checkChargeByBillingSaveNode(requestData).finally(
        () => loading.close()
      )
      if (response && response.data) {
        // 检查是否有校验失败的项
        const hasValidationErrors = this.checkValidationResult(response.data)

        return {
          needShowDialog: hasValidationErrors,
          data: response.data
        }
      }
    },

    // 检查校验结果是否有错误
    checkValidationResult(validationData) {
      if (!validationData) return false

      for (const key in validationData) {
        const rules = validationData[key]
        if (Array.isArray(rules)) {
          for (const rule of rules) {
            if (!rule.match && !rule.continueCheck) {
              return true // 有不匹配且不能继续的规则
            }
            if (!rule.match && rule.checkMode === 1) {
              return true // 有不匹配的错误级别规则
            }
          }
        }
      }
      return false
    },

    // 显示账单校验弹窗
    showBillingValidationDialog(validationData) {
      // 转换校验数据为CheckingSaveJobWindow组件需要的格式
      const convertedData = this.convertValidationDataForCheckingSaveJobWindow(validationData)

      this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NODE_SAVE_BILLING.code
      this.checkingSaveJobWindow.rowData = convertedData
      this.checkingSaveJobWindow.callBack = this.saveBillHandler
      this.checkingSaveJobWindow.visible = true
      this.checkingSaveJobWindow.lob = this.rowData[0].jobLob
    },

    // 转换校验数据格式以适配CheckingSaveJobWindow组件
    convertValidationDataForCheckingSaveJobWindow(validationData) {
      const result = []
      for (const key in validationData) {
        const rules = validationData[key]
        if (Array.isArray(rules)) {
          // 直接使用校验规则数据，CheckingSaveJobWindow会处理展示
          result.push(...rules)
        }
      }
      return result
    },
    // 国外账单保存
    async saveBillHandler() {
      if (this.splitBillButton) {
        await this.saveSplitBillingHandler()
      } else {
        if (!await this.validate(this.billing)) { return }
        this.billing.removedCharges = this.removedCharges

        // 组装更新的费用(加入&修改税率的费用)
        const updateCharges = []
        for (const charge of this.billing.charge) {
          // 判断是否是新加入的费用
          if (StrUtils.isEmpty(charge.billingUuid)) {
            updateCharges.push(charge)
          } else {
            //  判断是否修改了税率的费用
            const oldCharge = this.propBilling.charge.find(x => x.uuid === charge.uuid)
            if (Number(oldCharge.taxRate) !== Number(charge.taxRate)) {
              updateCharges.push(charge)
            }
          }
        }
        this.billing.updateCharges = updateCharges
        // billing 上的 业务信息移至后端

        // 账单所属分公司
        this.billing.branchId = (this.currentBillingBranchId > 0) ? this.currentBillingBranchId : this.$store.getters.currentOfficeId
        if (StrUtils.isEmpty(this.billing.uuid)) {
          this.billing.inputBy = this.user.userId
        }
        this.billing.titleBranchId = this.mainOffice
        if (this.billing.counterPartyBillingNo) {
          const res = await checkPartyBillingNoExist({
            branchId: this.billing.branchId,
            billKey: this.billing.uuid,
            billingType: this.billing.billingType,
            counterPartyBillingNo: this.billing.counterPartyBillingNo
          })
          if (res.data) {
            const flag = await this.$confirm(this.$t('Billing.OppositeBillNoAlreadyExists'), this.$t('Message.Prompt'), {
              confirmButtonText: this.$t('common.btn.ok'),
              cancelButtonText: this.$t('common.btn.cancel'),
              dangerouslyUseHTMLString: true,
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => true).catch(() => false)
            if (!flag) {
              return
            }
          }
        }
        // 校验开票抬头和结算代理
        const message = await this.checkAgentAndTitle()
        let isSave = true
        if (!StrUtils.isEmpty(message)) {
          isSave = false
          await this.$confirm(message, this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            distinguishCancelAndClose: true,
            type: 'warning'
          }).then(() => {
            isSave = true
          }).catch(() => {})
        }
        if (isSave) {
          this.fullscreenLoading = getLoading()
          this.billing.location = this.location
          if (this.billing.revoked && ((this.billing.createCharges && this.billing.createCharges.length > 0) || (this.billing.updateCharges && this.billing.updateCharges.length > 0))) {
            this.billing.revoked = false
          }
          // 调用api illing上 业务相关信息赋值 移至后端处理
          saveOverseaBilling(this.billing).then(res => {
            this.saveHandler(res.data)
          }).catch(() => {
            this.fullscreenLoading.close()
          })
        }
      }
    },
    // 保存成功后回调事件
    async saveHandler(_billing) {
      this.fullscreenLoading.close()
      this.$message.success(this.$t('Message.SaveSuccessfully'))

      // 处理账单号
      if (!StrUtils.isEmpty(_billing.counterPartyBillingNo)) {
        if (StrUtils.isEmpty(_billing.billingNo)) {
          await setBillingNo({ billKey: _billing.uuid, unchangState: true, location: this.location })
        }
      }

      LocalStorageUtils.setConfiguration('showLclCharge', this.chkShowLclSelected)
      this.innerVisible = false
      // 触发父级组件方法
      this.$emit('onCloseCallBackFun')
    },
    // 保存前校验
    async validate(billing) {
      if (billing.charge === null || billing.charge.length === 0) {
        this.$message.warning(this.$t('Message.ChargeCannotBeEmpty'))
        return false
      }
      for (const charge of billing.charge) {
        if (charge.offsetState === 1 || charge.offsetState === 2) {
          this.$message.warning(this.$t('Message.ChargeOffsetState'))
          return false
        }
      }
      if (!await this.checkChargeRateIsNaN()) {
        return false
      }
      if (isNaN(billing.rate) || billing.rate === 0) {
        this.$message.warning(this.$t('Message.BillOfExchangeCannotBeEmpty'))
        return false
      }
      if (billing.accoundId <= 0) {
        this.$message.warning(this.$t('Message.SettlementAgentCannotBeNull'))
        return false
      }
      // 是否允许多币种创建账单
      await cache.load(cacheName.CONFIG)
      const judgmentOfBillCurrency = Number(cache.config.get('JudgmentOfBillCurrency')) === 1
      if (judgmentOfBillCurrency) {
        let hasMoreCurrency = false
        let currency = null
        for (const charge of billing.charge) {
          if (currency == null) {
            currency = charge.currency
          } else if (currency && currency !== charge.currency) {
            hasMoreCurrency = true
            break
          }
        }
        if (hasMoreCurrency) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CurrencyMustBeTheSame'))
          return false
        }
      }
      if (!billing.inputDate) {
        this.$message.warning(this.$t('Billing.billingJob_inputDateNotEmpty'))
        return false
      }
      return this.isIncludeAdvanceCharge()
    },
    /**
     * 是否包含了不同类型的费用(代收垫付/普通)
     */
    isIncludeAdvanceCharge() {
      const _billing = this.billing
      const isAdvance = _billing.charge[0].advance
      for (const charge of _billing.charge) {
        if (charge.advance !== isAdvance) {
          this.$message.warning(this.$t('Message.CollectingAdvanceBillingAndGeneralExpensesCannotBeTogether'))
          return false
        }
      }
      return true
    },
    /**
     * 验证汇率是否维护
     */
    async checkChargeRateIsNaN() {
      const billing = this.billing
      for (const row of billing.charge) {
        let rate = 0
        if (this.isSaveBillRate) {
          rate = BillingRateUtil.getForeignExchangeRateSafely(billing.currency, row.currency, billing.inputDate)
        } else {
          rate = await RateUtil.getForeignExchangeRateSafely(billing.currency, row.currency, billing.inputDate, billing.branchId)
        }
        if (isNaN(rate) || rate === 0) {
          this.$message.warning(this.$t('Message.CurrencyExchangeRateIsNotMaintained1') + '[' + row.currency + ']' + this.$t('Message.CurrencyExchangeRateIsNotMaintained2'))
          return false
        }
      }
      return true
    },
    arapComboBoxLabelEnFunc(value) {
      return value === true ? 'DEBIT' : 'CREDIT'
    },
    // 显示小票费用
    chkChangeHandler() {
      this.refreshBillingChargeAccounts()
      this.accountCodeChangeEvent()
    },
    /**
     * 结算对象下拉刷新
     */
    async refreshBillingChargeAccounts() {
      this.billingChargeAccounts = []
      const accountMap = {}
      for (let i = this.billingChargeDetail.length - 1; i >= 0; i--) {
        const charge = this.billingChargeDetail[i]
        if (!accountMap.hasOwnProperty(charge.accountId) && (this.chkShowLclSelected ? true : charge.jobUuid === this.job.uuid)) {
          const o = {}
          o.label = await Company.getCompanyName(Number(charge.accountId))
          o.data = charge.accountId
          accountMap[charge.accountId] = charge.accountId
          this.billingChargeAccounts.push(o)
        }
      }
    },
    // 查询结算对象联系人
    async queryAccountContact(accountId) {
      if (accountId > 0) {
        let contacts = this.contactListMap[accountId]
        if (!contacts) {
          contacts = await getContactList({ cmpIdx: accountId }).then(res => res.data.list)
          this.contactListMap[accountId] = contacts
        }
        this.accountContactsArray = contacts
        if (contacts.length > 0) {
          if (!this.billing.uuid) { // 新增的时候，默认带出联系人信息
            for (const contact of contacts) {
              if (contact.defaultContact) {
                this.billing.accountContacts = contact.contactPerson
                this.billing.accountContactsTel = contact.telephone
                break
              }
            }
          }
        } else {
          this.billing.accountContacts = ''
          this.billing.accountContactsTel = ''
        }
      }
    },
    // 结算单位联系人
    accountContactChangeEvent(contact) {
      if (contact) {
        this.billing.accountContacts = contact.contactPerson
        if (contact.hasOwnProperty('telephone')) {
          this.billing.accountContactsTel = contact.telephone
        }
      }
    },
    // 查询开票抬头
    async queryTitleList2(accountId) {
      let titleArray = this.titleByCpmIdxMap[accountId]
      if (!titleArray) {
        const res = await queryTitleByCpmIdx(accountId)
        if (res && res.data) {
          titleArray = res.data
          this.titleByCpmIdxMap[accountId] = titleArray
        }
      }
      this.titleArray = titleArray
      if (!this.billing.uuid) { // 账单新增
        // 根据结算对象ID获取结算对象
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.billing.accountId))
        if (company) {
          if (!titleArray || titleArray.length === 0) {
            const defaultName = this.getCompanyName(company)
            titleArray.push({ title: defaultName, uuid: defaultName, taxAccount: '' })
            this.billing.title = defaultName
            this.invoiceTitleUuid = defaultName
          } else {
            for (let i = 0; i < titleArray.length; i++) {
              const item = titleArray[i]
              this.billing.title = item['title']
              this.billing.buyerTaxAccount = item['taxAccount']
              this.billing.customerEmail = item['email'] || ''
              this.invoiceTitleUuid = item.uuid
              if (item['defaultTitle'] === true) {
                break
              }
            }
          }
        }
      }
    },
    getCompanyName(company) {
      if (company) {
        if (this.$store.getters.language === 'zh') {
          if (company.chineseName && company.chineseName.trim() === '') {
            return company.englishName || ''
          }
          return company.chineseName || ''
        } else {
          return company.englishName || ''
        }
      }
      return ''
    },
    // 查询开票抬头
    queryTitleList(accountId, hasTitle = false) {
      queryTitleByCpmIdx(accountId).then(async(res) => {
        let titleArray = []
        if (res.data && res.data.length > 0) {
          titleArray = res.data
        }
        const title = this.billing.title
        let realTitle = true
        if (title) {
          if (!titleArray.find(item => item.title === title)) {
            titleArray.push({ title: title, uuid: title, taxAccount: '' })
            this.invoiceTitleUuid = title
            realTitle = false
          } else {
            const titles = titleArray.filter(t => t.title === title)
            if (titles.length === 1) {
              this.invoiceTitleUuid = titles[0].uuid
              BillingNativeUtils.setBillingTitle(this.billing, titles[0])
            } else if (titles.length > 1) {
              const title = titles.find(item => item.taxAccount === this.billing.buyerTaxAccount)
              if (title) {
                this.invoiceTitleUuid = title.uuid
                BillingNativeUtils.setBillingTitle(this.billing, title)
              } else {
                this.invoiceTitleUuid = titles[0].uuid
                BillingNativeUtils.setBillingTitle(this.billing, titles[0])
              }
            }
          }
        }
        this.titleArray = titleArray
        if (!this.billing.uuid) { // 账单新增
          // 根据结算对象ID获取结算对象
          const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.billing.accountId))
          if (!hasTitle) {
            if (!titleArray || titleArray.length === 0) {
              this.billing.title = company ? company['chineseName'] : null
            } else {
              for (let i = 0; i < titleArray.length; i++) {
                const item = titleArray[i]
                if (item['defaultTitle'] === true) {
                  this.invoiceTitleUuid = item.uuid
                  BillingNativeUtils.setBillingTitle(this.billing, item)
                  break
                }
              }
            }
          } else {
            const titles = titleArray.filter(title => title.title === this.billing.title)
            if (titles.length > 0) {
              if (titles.length === 1) {
                this.invoiceTitleUuid = titles[0].uuid
                BillingNativeUtils.setBillingTitle(this.billing, titles[0])
              }
              if (titles.length > 1) {
                const title = titles.find(item => item.taxAccount === this.billing.buyerTaxAccount)
                if (title) {
                  this.invoiceTitleUuid = title.uuid
                  BillingNativeUtils.setBillingTitle(this.billing, title)
                } else {
                  this.invoiceTitleUuid = titles[0].uuid
                  BillingNativeUtils.setBillingTitle(this.billing, titles[0])
                }
              }
            }
          }
          if (realTitle) {
            await BillingNativeUtils.getTitleBankByTitle(this.billing, this.invoiceTitleUuid)
          }
        }
        if (this.billing.title) {
          let title = null
          for (let i = 0; i < titleArray.length; i++) {
            const item = titleArray[i]
            if (item['uuid'] === this.invoiceTitleUuid) {
              title = item
              break
            }
          }
          this.getTitleBankByTitle(title)
        } else {
          this.getTitleBankByTitle()
        }
      })
    },
    // 开票抬头变更回调函数
    titleChangeEvent(titleItem) {
      const billing = this.billing
      this.invoiceTitleUuid = titleItem['uuid']
      billing.title = titleItem['title']
      billing.buyerTaxAccount = titleItem['taxAccount']
      billing.customerEmail = titleItem['email'] || ''
      this.changeStatus = true
      this.getTitleBankByTitle(titleItem)
    },
    // 获取开票抬头所维护的开票银行
    async getTitleBankByTitle(title = null) {
      const billing = this.billing
      let changeStatus = this.changeStatus
      if (title) {
        if (title['uuid'] && title['uuid'] !== title['title']) {
          const titleUuidList = title['uuid']
          await getTitleBankList({ titleUuidList: [titleUuidList] }).then((res) => {
            const titleBanks = res.data
            if (titleBanks && titleBanks.length > 0 || (billing.buyerBank !== null && billing.buyerBank !== '')) {
              if (!titleBanks.find(item => item.bank === billing.buyerBank && item.bankAccount === billing.buyerBankAccount)) {
                titleBanks.push({ bank: billing.buyerBank, uuid: billing.uuid, bankAccount: billing.buyerBankAccount })
              }
              this.titleBankArray = titleBanks
              if (!billing.uuid || changeStatus) {
                for (let i = 0; i < titleBanks.length; i++) {
                  const bank = titleBanks[i]
                  if (bank['defaultBank'] === true) {
                    this.titleBankUuid = bank['uuid']
                    billing.buyerBank = bank['bank']
                    billing.buyerBankAccount = bank['bankAccount']
                    break
                  }
                }
              } else { // 编辑状态下，根据开户银行名称和账号定位UUID
                for (const bank of titleBanks) {
                  if (bank.bank === billing.buyerBank && billing.buyerBankAccount === bank.bankAccount) {
                    this.titleBankUuid = bank['uuid']
                    break
                  }
                }
              }
            } else {
              this.titleBankArray = []
              this.titleBankUuid = ''
              billing.buyerBank = ''
              billing.buyerBankAccount = ''
            }
          })
        } else {
          this.titleBankUuid = ''
          billing.buyerBank = ''
          billing.buyerBankAccount = ''
        }
        if (!billing.uuid || changeStatus) {
          // 账单新增
          changeStatus = false
          billing.buyerTaxAccount = title['taxAccount']
          billing.buyerAddress = title['address']
          billing.buyerTelephone = title['telephone']
        }
      } else {
        if (!billing.uuid) {
          billing.buyerTaxAccount = ''
          billing.buyerAddress = ''
          billing.buyerTelephone = ''
        }
        this.titleBankArray = []
        this.titleBankUuid = ''
        billing.buyerBank = ''
        billing.buyerBankAccount = ''
      }
      this.changeStatus = changeStatus
    },
    async inputDateChange() {
      await this.updateBillingRate()
      await this.fillRate(this.billing.currency)
      this.changeOurBankByCurrency()
      await this.calculateAmount()
    },
    // 校验开票抬头和结算代理
    async checkAgentAndTitle() {
      // CARGO-32484 国外账单页签移除费用后依然报错结算代理不一致
      // const charges = this.billingChargeDetail
      const charges = this.billing.charge
      let message = ''
      if (charges && charges.length > 0) {
        let title = ''
        let isSame = true
        let settlementAgentId = 0
        let isSameSettlementAgent = true
        for (const charge of charges) {
          // 忽略开票抬头为空的数据
          if (StrUtils.isEmpty(charge.invoiceTitle)) {
            continue
          }
          if (StrUtils.isEmpty(title)) {
            title = charge.invoiceTitle
            continue
          }
          if (title !== charge.invoiceTitle) {
            isSame = false
            break
          }
        }
        for (const charge of charges) {
          if (!charge.settlementAgentId) {
            continue
          }
          if (settlementAgentId === 0) {
            settlementAgentId = charge.settlementAgentId
            continue
          }
          if (settlementAgentId !== charge.settlementAgentId) {
            isSameSettlementAgent = false
            break
          }
        }
        if (!isSame && !isSameSettlementAgent) {
          message = this.$t('Message.SettlingAgentInvoiceTitleInconsistent')
        } else if (isSame && !isSameSettlementAgent) {
          message = this.$t('Message.SettlingAgentInconsistent')
        } else if (!isSame && isSameSettlementAgent) {
          message = this.$t('Message.TheTitleOfTheInvoiceIsInconsistentDoYouWantToContinue')
        }
      }
      return message
    },
    // 显示拆分账单详细
    async splitOnshow() {
      const splitCurrencyList = { ...this.splitCurrencyList }
      const splitBillData = this.splitBillData
      const currency = splitCurrencyList[this.nowPage]
      // 根据账单币种取计算好的账单数据
      this.billing = splitBillData[currency]
      // 列表使用账单中记录费用
      this.rowData = this.billing.charge
      // 计算账单金额
      await this.fillChangedCurrency(this.billing, true)
    },
    // 上一张
    theLastPageHandler() {
      if (this.nowPage > 0) {
        this.nowPage = this.nowPage - 1
      }
      this.splitOnshow()
    },
    // 下一张
    theNextPageHandler() {
      // 小于最大页数
      if (this.nowPage < this.splitCurrencyList.length - 1) {
        this.nowPage = this.nowPage + 1
      }
      this.splitOnshow()
    },
    async setSplitCurrencyData(list) {
      for (const c of list) {
        if (!this.splitCurrencyList.includes(c.currency)) {
          this.splitCurrencyList.push(c.currency)
        }
      }
      if (this.splitCurrencyList.length === 0) {
        const defaultCurrency = this.getDefaultCurrency()
        this.splitCurrencyList.push(defaultCurrency)
      }
      // 根据币种生成对应账单
      for (const billCurrency of this.splitCurrencyList) {
        // 根据币种生成对应账单
        let currencyBill = this.splitBillData[billCurrency]
        if (currencyBill === undefined || currencyBill === null) {
          currencyBill = { ... this.billing }
          currencyBill.currency = billCurrency
          await this.setBankData(currencyBill)
          // 计算费用列表
          const chargeList = this.getChargesForCurrency(currencyBill.currency, currencyBill.charge)
          // 拆分的费用 挂在账单上
          currencyBill.charge = chargeList
          // 计算账单金额
          await this.fillChangedCurrency(currencyBill, true)
          this.splitBillData[billCurrency] = currencyBill
        }
      }
    },
    // 触发按费用拆分账单
    async splitBillChangeEvent(event) {
      this.billing = null
      this.nowPage = 0
      await this.onShow(event ? '1' : '0')
    },
    // 获取指定币种的费用
    getChargesForCurrency(currency, list) {
      const rList = []
      for (const c of list) {
        if (c.currency === currency) {
          rList.push(c)
        }
      }
      return rList
    },
    // 保存拆分账单
    async saveSplitBillingHandler() {
      let passThrough = true
      const splitBillData = { ...this.splitBillData }
      const counterPartyBillingNoList = []
      let tips = false
      let tipMessage = ''
      for (const key of Object.keys(splitBillData)) {
        const billing = splitBillData[key]
        passThrough = await this.validate(billing)
        // 有一个报错就不用在继续
        if (!passThrough) {
          break
        }
        if (billing.counterPartyBillingNo) {
          if (counterPartyBillingNoList.includes(billing.counterPartyBillingNo)) {
            // 拆分账单中存在对方账单号重复
            tips = true
          } else {
            counterPartyBillingNoList.push(billing.counterPartyBillingNo)
          }
        }
        const message = await this.checkAgentAndTitle()
        if (message) {
          tipMessage += '【' + key + '】账单:' + message + '\n'
        }
        // 组装更新的费用(加入&修改税率的费用)
        const updateCharges = []
        for (const charge of billing.charge) {
          // 判断是否是新加入的费用
          if (StrUtils.isEmpty(charge.billingUuid)) {
            updateCharges.push(charge)
          } else {
            //  判断是否修改了税率的费用
            const oldCharge = this.propBilling.charge.find(x => x.uuid === charge.uuid)
            if (Number(oldCharge.taxRate) !== Number(charge.taxRate)) {
              updateCharges.push(charge)
            }
          }
        }
        billing.updateCharges = updateCharges
        // 账单所属分公司
        billing.branchId = (this.currentBillingBranchId > 0) ? this.currentBillingBranchId : this.$store.getters.currentOfficeId
        billing.inputBy = this.user.userId
        billing.titleBranchId = this.mainOffice
      }
      if (passThrough) {
        let resData = 0
        if (!tips && counterPartyBillingNoList.length > 0) {
          // 后端接口检查 拆分账单中是否存在对方账单号重复
          const res = await batchCheckPartyBillingNoExist(counterPartyBillingNoList, {
            branchId: this.billing.branchId,
            billKey: this.billing.uuid,
            billingType: this.billing.billingType
          })
          resData = res.data
        }
        // 拆分账单中存在重复 或后端检查出重复
        if (tips || resData > 0) {
          const flag = await this.$confirm(this.$t('Billing.OppositeBillNoAlreadyExists'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            dangerouslyUseHTMLString: true,
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => true).catch(() => false)
          if (!flag) {
            return
          }
        }
        let isSave = true
        if (!StrUtils.isEmpty(tipMessage)) {
          isSave = false
          await this.$confirm(tipMessage, this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            distinguishCancelAndClose: true,
            type: 'warning'
          }).then(() => {
            isSave = true
          }).catch(() => {})
        }
        if (isSave) {
          this.btnSaveEnable = true
          this.fullscreenLoading = getLoading4Cxt(this)
          // 调用api illing上 业务相关信息赋值 移至后端处理
          const billList = []
          const splitBillData = { ...this.splitBillData }
          Object.keys(splitBillData).forEach(key => {
            const billing = splitBillData[key]
            const newCharges = []
            const editCharges = []
            for (const charge of billing.charge) {
              if (charge._charge) {
                if (charge._charge.uuid) {
                  editCharges.push(charge._charge)
                } else {
                  newCharges.push(charge._charge)
                }
              }
            }
            billing.newCharges = newCharges
            billing.editCharges = editCharges
            if (billing.deletedChargeKeys && billing.deletedChargeKeys.length > 0) {
              const saveChargeKeySet = billing.charge.filter(p => p.uuid).map(p => p.uuid)
              billing.deletedChargeKeys = billing.deletedChargeKeys.filter(p => !saveChargeKeySet.includes(p))
            }
            billList.push(billing)
          })
          saveOverseaSplitBillingFunc(billList, this.location).then(res => {
            this.saveSplitHandler()
          }).catch(() => {
            this.fullscreenLoading.close()
          })
        }
      }
    },
    // 保存成功后回调事件
    async saveSplitHandler() {
      this.fullscreenLoading.close()
      this.$message.success(this.$t('Message.SaveSuccessfully'))
      this.innerVisible = false
      LocalStorageUtils.setConfiguration('showLclCharge', this.chkShowLclSelected)
      // 触发父级组件方法
      this.$emit('onCloseCallBackFun')
    },
    // 更新账单汇率
    async updateBillingRate() {
      const localCurrency = this.currentBillingBranchId > 0 ? RateUtil.localCurrencyByOfficeId(this.currentBillingBranchId) : RateUtil.localCurrencyByOffice()
      if (this.isSaveBillRate) {
        this.billing.rate = BillingRateUtil.getForeignExchangeRateSafely(localCurrency, this.billing.currency, this.billing.inputDate)
      } else {
        this.billing.rate = await RateUtil.getForeignExchangeRateSafely(localCurrency, this.billing.currency, this.billing.inputDate, this.currentBillingBranchId > 0 ? this.currentBillingBranchId : this.$store.getters.currentOfficeId)
      }
      this.billing.rate = NumberUtils.roundHalfUp(this.billing.rate, 8) // CARGO-7779
    },
    getInstructionBtnType(item) {
      if (item.platformInstructionRuleCode === 'overseaBillEdit' && item.instructionParamJson.editType === '删除费用') {
        return 'danger'
      }
      return 'primary'
    },
    getInstructionLabel(item) {
      if (item.platformInstructionRuleCode === 'overseaBillEdit') {
        if (item.instructionParamJson.editType === '新增费用') {
          return this.$t('CargoMsg.Cargo_AddCharges')
        }
        if (item.instructionParamJson.editType === '编辑费用') {
          return this.$t('SeaExport.EditCharges')
        }
        if (item.instructionParamJson.editType === '删除费用') {
          return this.$t('CargoMsg.Cargo_DeleteFee')
        }
      }
      return this.$selectByLang(item.chineseName, item.englishName, item.japaneseName)
    },
    onInstructionClick(data) {
      if (data.platformInstructionRuleCode === 'overseaBillEdit') {
        if (data.instructionParamJson.editType === '新增费用') {
          this.addBillCharge()
        }
        if (data.instructionParamJson.editType === '编辑费用') {
          this.editBillCharge()
        }
        if (data.instructionParamJson.editType === '删除费用') {
          this.removeBillCharge()
        }
      }
    },
    async addBillCharge() {
      const charge = new Charge().fillDefaultValue().getData()
      charge.currency = this.billing.currency
      charge.accountId = this.billing.accountId
      charge.settlementAgentId = this.billing.settlementAgentId
      charge.invoiceTitle = this.billing.title

      await BookingUtil.getNewCharge(charge, this.job, this.billing.ar)
      // 重新赋值，因为BookingUtil.getNewCharge会修改charge.accountId
      charge.accountId = this.billing.accountId

      await ChargeUtils.getChargeisOverseaNotControlledByConfig(charge)
      // 重新赋值，因为ChargeUtils.getChargeisOverseaNotControlledByConfig会修改charge.oversea
      charge.oversea = this.billing.billingType === BILLING_TYPE_OVERSEA.code

      charge.refId = this.autoIncrementNum.getNextNum()
      charge.jobNo = this.job.jobNo
      this.showBillEditChargeDialog(charge)
    },
    async editBillCharge() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length !== 1) {
        this.$message.warning(this.$t('queryJob.PleaseAFeeToEdit'))
        return
      }
      const row = rows[0]
      if (!row._charge && row.uuid) {
        row._charge = await getChargeByUuid(row.uuid).then(res => res.data)
        row.refId = row._charge.refId = this.autoIncrementNum.getNextNum()
      }
      const charge = row._charge
      if (!charge) {
        return
      }
      if (!await ChargeUtils.chargeIsModified({ ...charge, billingUuid: '' }, { uuid: charge.jobUuid })) {
        this.$message.warning(this.$t('queryJob.ThisFeeIsNotEditable'))
        return
      }
      charge.jobNo = rows[0].jobNo
      this.showBillEditChargeDialog(charge)
    },
    showBillEditChargeDialog(charge) {
      const jobMap = new Map()
      const currencySet = new Set()
      for (const item of this.billing.charge) {
        if (charge.uuid && charge.uuid === item.uuid) {
          continue
        }
        jobMap.set(item.jobUuid, { uuid: item.jobUuid, jobNo: item.jobNo })
        currencySet.add(item.currency)
      }
      jobMap.set(charge.jobUuid, { uuid: charge.jobUuid, jobNo: charge.jobNo })
      this.billEditChargeDialog.title = charge.uuid ? this.$t('SeaExport.EditCharges') : this.$t('CargoMsg.Cargo_AddCharges')
      this.billEditChargeDialog.simpleJobs = [...jobMap.values()]
      this.billEditChargeDialog.charge = charge
      this.billEditChargeDialog.currencyList = this.splitBillButton ? [this.billing.currency] : [...currencySet]
      this.billEditChargeDialog.visible = true
    },
    saveBillEditChargeCallback(billCharge) {
      billCharge.refId = billCharge._charge.refId
      this.selectedChargeEvent([billCharge])
    },
    removeBillCharge() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('queryJob.PleaseFeesYouWantDelete'))
        return
      }
      this.$confirm(this.$t('queryJob.AreWantToDeleteExpense'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('Message.Confirm'),
        cancelButtonText: this.$t('common.btn.cancel'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(async() => {
        await this.loadJobChargeCache(rows.map(p => p.jobUuid))
        const deleteRows = []
        for (const row of rows) {
          const charge = this.getCharge(row)
          if (!charge) {
            continue
          }
          if (charge.uuid && !await ChargeUtils.chargeIsDeleted({ ...charge, billingUuid: '' }, this.job.lob, this.jobChargeCache)) {
            continue
          }
          deleteRows.push(row)
        }
        if (deleteRows.length === 0) {
          return
        }
        await this.deleteBillChargeEvent(deleteRows)
      })
    },
    async loadJobChargeCache(jobKeys) {
      for (const jobKey of jobKeys) {
        if (this.jobChargeCache.has(jobKey)) {
          continue
        }
        if (jobKey === this.job.uuid && this.job.charges) {
          this.jobChargeCache.set(jobKey, this.job.charges)
          continue
        }
        const jobModel = await new Job({ uuid: jobKey }).loadJobRelated({ charges: true })
        this.jobChargeCache.set(jobKey, jobModel.charges || [])
      }
    },
    getCharge(row) {
      if (row._charge) {
        return row._charge
      }
      const charges = this.jobChargeCache.get(row.jobUuid)
      return charges?.find(c => c.uuid === row.uuid) || null
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .operations{
  .triggers{
    justify-content: space-between;
  }
}
</style>
